import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { BlueIconsComponent } from './blue-icons/blue-icons.component';
import { ButtonIconComponent } from './button-icon/button-icon.component';
import { DashboardIconComponent } from './dashboard-icon/dashboard-icon.component';
import { EmptyStateIconsComponent } from './empty-state-icons/empty-state-icons.component';
import { GreyIconsComponent } from './grey-icons/grey-icons.component';




@NgModule({
	declarations: [
		GreyIconsComponent,
		BlueIconsComponent,
		EmptyStateIconsComponent,
		DashboardIconComponent,
		ButtonIconComponent
	],
	imports: [
		CommonModule,
		NzIconModule
	],
	exports: [
		GreyIconsComponent,
		BlueIconsComponent,
		EmptyStateIconsComponent,
		DashboardIconComponent,
		ButtonIconComponent
	]
})
export class LeanIconsModule { }
